module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY5Ni43IDUzNGwtMi45IDMuNC0yLjUgMi4yLTI0NyAyNDkuOWEzNSAzNSAwIDAgMS00OS45IDAgMzYgMzYgMCAwIDEtMi45LTQ3LjFsMy0zLjRMNjE4LjcgNTEybC0yMjQuNC0yMjdhMzYgMzYgMCAwIDEtMy00Ny4xbDMtMy40YTM1IDM1IDAgMCAxIDQ5LjkgMGwyNDcgMjQ5LjkgMi41IDIuM2M2LjQgNi40IDkuOCAxNC43IDEwLjMgMjMuMXY0LjVhMzUuOCAzNS44IDAgMCAxLTcuMyAxOS44eiIgZmlsbD0iIzAiIHAtaWQ9IjY2NCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Chevron right-outlined.svg
// module id = 64V9
// module chunks = 75